import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButton, MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenPasswordResetComponent } from "./components/loren-password-reset/loren-password-reset.component";
import { LorenPasswordResetRoutingModule } from "./loren-password-reset-routing.module";
import { LorenEntityFormModule } from "../../shared/modules/loren-entity-form/loren-entity-form.module";
import { LorenPasswordResetTokenResolver } from "./resolvers/loren-password-reset-token.resolver";

@NgModule({
  declarations: [LorenPasswordResetComponent],
  imports: [
    LorenPasswordResetRoutingModule,
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatCardModule,
    MatIconModule,
    ReactiveFormsModule,
    MatInputModule,
    LorenEntityFormModule,
    TranslocoModule,
    MatButton,
  ],
  providers: [LorenPasswordResetTokenResolver],
})
export class LorenPasswordResetModule {}
